import React from 'react';
import PropTypes from 'prop-types';
import { uiStyles } from 'lib/uiUtils';
import { Box, Button } from '@material-ui/core';

/* Ações padrão dos formulários */
const FormActions = ({
    cancelButtonProps,
    cancelLabel,
    disableCancel,
    disableSave,
    onCancel,
    onSave,
    saveButtonProps,
    saveLabel
}) => (
    <Box style={uiStyles.formActions}>
        <Button
            name="cancelar"
            color="secondary"
            variant="contained"
            onClick={onCancel}
            disabled={disableCancel}
            {...cancelButtonProps}
        >
            {cancelLabel}
        </Button>

        <Button
            name="salvar"
            color="primary"
            variant="contained"
            onClick={onSave}
            disabled={disableSave}
            {...saveButtonProps}
        >
            {saveLabel}
        </Button>
    </Box>
);

FormActions.propTypes = {
    cancelButtonProps: PropTypes.object,
    cancelLabel: PropTypes.string,
    disableCancel: PropTypes.bool,
    disableSave: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    saveButtonProps: PropTypes.object,
    saveLabel: PropTypes.string
};

FormActions.defaultProps = {
    cancelButtonProps: {},
    cancelLabel: 'Cancelar',
    disableCancel: false,
    disableSave: false,
    saveButtonProps: {},
    saveLabel: 'Salvar'
};

export default FormActions;